<template>
  <div class="editor-container">
    <div ref="toolbar" class="editor-toolbar"></div>
    <div ref="editor" class="editor-content"></div>
  </div>
</template>

<script>
import E from 'wangeditor'

export default {
  name: 'AdvancedWangEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 500
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    }
  },
  data() {
    return {
      editor: null,
      editorContent: this.value
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.editorContent && this.editor) {
        this.editor.txt.html(newVal)
      }
    },
    height(newHeight) {
      if (this.editor) {
        this.editor.config.height = newHeight
      }
    }
  },
  mounted() {
    this.initEditor()
  },
  beforeDestroy() {
    this.destroyEditor()
  },
  methods: {
    initEditor() {
      const editor = new E(this.$refs.toolbar, this.$refs.editor)
      this.editor = editor

      // 基本配置
      editor.config.zIndex = 100
      editor.config.placeholder = this.placeholder
      editor.config.height = this.height

      // 菜单配置
      editor.config.menus = [
        'head',
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'foreColor',
        'backColor',
        'link',
        'list',
        'justify',
        'quote',
        'image',
        'table',
        'code',
        'undo',
        'redo'
      ]

      // 颜色配置
      editor.config.colors = [
        '#000000',
        '#eeece0',
        '#1c487f',
        '#4d80bf',
        '#c24f4a',
        '#8baa4a',
        '#7b5ba1',
        '#46acc8',
        '#f9963b',
        '#ffffff'
      ]

      // 图片上传配置
      editor.config.uploadImgServer = '/api/upload'
      editor.config.uploadFileName = 'file'
      editor.config.uploadImgHeaders = {
        'Authorization': 'Bearer ' + this.$store.getters.token
      }
      editor.config.uploadImgHooks = {
        customInsert: (insertImgFn, result) => {
          if (result.code === 200) {
            insertImgFn(result.data.url)
          } else {
            this.$message.error(result.message || '图片上传失败')
          }
        }
      }

      // 内容变化回调
      editor.config.onchange = (html) => {
        this.editorContent = html
        this.$emit('input', html)
        this.$emit('change', html)
      }

      // 创建编辑器
      editor.create()

      // 设置初始内容
      if (this.value) {
        editor.txt.html(this.value)
      }
    },
    destroyEditor() {
      if (this.editor) {
        this.editor.destroy()
        this.editor = null
      }
    },
    // 外部可调用的方法
    clear() {
      if (this.editor) {
        this.editor.txt.clear()
      }
    },
    getHtml() {
      return this.editor ? this.editor.txt.html() : ''
    },
    getText() {
      return this.editor ? this.editor.txt.text() : ''
    }
  }
}
</script>

<style scoped>
.editor-container {
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.editor-toolbar {
  border-bottom: 1px solid #ccc;
}

.editor-content {
  overflow-y: auto;
}
/deep/.w-e-toolbar .w-e-menu {
  font-size: 16px;
}
/deep/.w-e-menu-tooltip{
  font-size: 16px;
}
</style>
